<div class="voices-top-section">
    <div class="app-l-container">
        <div class="app-l-page__navigation">
            <div class="app-l-page__previous" (click)="goBack()">
                <button
                    class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
                    <svg-icon icon="arrowLeft" class="w-100 h-100"></svg-icon>
                </button>
            </div>
            <nav class="app-l-page__breadcrumbs" aria-label="Breadcrumb">
                <ul class="breadcrumbs-list">
                    <li class="breadcrumbs-list-item">
                        <a [routerLink]="['/app/series']" translate>
                            series.title
                        </a>
                    </li>
                    <li
                        class="breadcrumbs-list-item app-l-current-page"
                        aria-current="page"
                        tabindex="0"
                        translate>
                        series.seriesTypes.reads
                    </li>
                </ul>
            </nav>
        </div>
        <div class="app-l-voices-banner">
            <div class="app-l-voices-banner__left">
                <h2 class="app-l-voices-banner__heading" translate>
                    series.seriesTypes.reads
                </h2>
                <!-- <h6 class="app-l-voices-banner__desc" translate>
                    Lorem ipsum dolor sit amet consectetur. Tortor sit vel.
                </h6> -->
            </div>
        </div>
    </div>
</div>

<div class="voice-series-main-container">
    <page-loader *ngIf="!loaded"></page-loader>
    <div class="series-type-section" *ngIf="loaded">
        <div class="app-l-sub-title-holder">
            <div class="app-l-subTitle">
                <!-- <span translate>series.voiceSeries.stories</span> -->
            </div>
            <!-- <div class="app-c-mat-select">
                <mat-select
                    [(ngModel)]="categorySelected"
                    class="app-l-dsh__cat_select"
                    [(value)]="selectedOption"
                    panelClass="app-l-dsh__cat_panel"
                    aria-label="Select reading category"
                    aria-haspopup="listbox"
                    (selectionChange)="getFilteredList()">
                    <ng-container *ngFor="let category of categoryList">
                        <mat-option
                            tabindex="0"
                            *ngIf="category.hasReads > 0"
                            [value]="category.ID"
                            translate>
                            {{ category.Title }}
                        </mat-option>
                    </ng-container>
                </mat-select>
            </div> -->
            <div class="app-c-custom-select">
                <div
                    class="app-c-select-trigger"
                    role="combobox"
                    aria-haspopup="listbox"
                    aria-autocomplete="none"
                    aria-label="Select story category"
                    aria-controls="reads-category-options"
                    [attr.aria-expanded]="isOpen"
                    tabindex="0"
                    (click)="isOpen = !isOpen"
                    (keydown.enter)="isOpen = !isOpen"
                    (keydown.space)="$event.preventDefault(); isOpen = !isOpen"
                    (keydown.escape)="isOpen = false">
                    <span>
                        <ng-container *ngFor="let category of categoryList">
                            <ng-container *ngIf="categorySelected === category.ID">{{ category.Title | translate }}</ng-container>
                        </ng-container>
                    </span>
                </div>

                <ul id="reads-category-options" class="app-c-select-list" *ngIf="isOpen" role="listbox" aria-label="Story category options">
                    <ng-container *ngFor="let category of categoryList">
                        <li *ngIf="category.hasReads > 0" [class.is-selected]="categorySelected === category.ID"
                            role="option"
                            tabindex="0"
                            [attr.aria-selected]="categorySelected === category.ID"
                            (click)="categorySelected = category.ID; isOpen = false; getFilteredList()"
                            (keydown.enter)="categorySelected = category.ID; isOpen = false; getFilteredList()"
                            (keydown.space)="$event.preventDefault(); categorySelected = category.ID; isOpen = false; getFilteredList()">
                            {{ category.Title | translate }}
                        </li>
                    </ng-container>
                </ul>
                </div>
        </div>
        <div class="series-type-list">
            <ng-container *ngFor="let reads of filteredReadableSeriesList">
                <article
                    tabindex="0"
                    role="button"
                    [attr.aria-label]="
                        reads['title' + lang] "
                    class="series-type-card type-allen"
                    (keydown.enter)="goToRead(reads)"
                    (keydown.space)="goToRead(reads)"
                    (click)="goToRead(reads)">
                    <div class="cover-image-section">
                        <img
                            [defaultImage]="
                                '../../../assets/img/series/reads.svg'
                            "
                            [lazyLoad]="reads.thumbnailUrl"
                            alt="{{ reads['title' + lang] }} cover image" />
                    </div>
                    <div class="card-content">
                        <span class="card-title">{{
                            reads ? reads['title' + lang] : ''
                        }}</span>
                    </div>
                </article>
            </ng-container>
        </div>
        <ng-container *ngIf="filteredReadableSeriesList.length == 0">
            <div class="empty-card">
                <div class="app-dm-positive-cards" translate>series.noData</div>
            </div>
        </ng-container>
    </div>
</div>
